import React, { useEffect, useState } from 'react';
import { Button } from '@ds';
import { ButtonStyle } from '@ds/elements/Button/Button.types';
import { useNavigate } from 'react-router-dom';
import { useCheckHasActiveUsCase } from 'src/shared/queries/useCheckHasActiveUsCase';
import styles from './I94Banner.module.scss';

interface I94BannerProps {
  displayUploadButton?: boolean;
  beneId?: number;
}

const I94Banner: React.FC<I94BannerProps> = ({ displayUploadButton = true, beneId }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const { data: hasActiveUsCase, isLoading: isUsCaseLoading } = useCheckHasActiveUsCase(beneId);

  useEffect(() => {
    if (hasActiveUsCase) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [hasActiveUsCase]);

  if (isUsCaseLoading) return <></>;

  if (!isVisible) return null;

  return (
    <div className={styles.I94Banner}>
      <div className={styles.iconAndText}>
        <span className={styles.icon} />
        <div className={styles.textContainer}>
          <p className={styles.title}>Have you entered the United States recently? Upload your most recent I-94 here.</p>
          <p className={styles.description}>
            The I-94 is your official arrival record and is evidence of your status and authorized stay in the United States. You are responsible for reviewing your latest I-94 and ensuring that your status is unexpired.{' '}
            Get your most recent I-94 on the{' '}
            <a href="https://i94.cbp.dhs.gov/search/recent-search" target="_blank" rel="noopener noreferrer">
              CBP website
            </a>
            .
          </p>
        </div>
      </div>
      <div className={styles.actions}>
        {displayUploadButton && (
          <Button styleType={ButtonStyle.secondary} onClick={() => navigate('/documents?uploadI94=true')}>
            Upload
          </Button>
        )}
      </div>
    </div>
  );
};

export default I94Banner;
